import React from "react";

const StickyHeadline = ({
  headline,
  navbarHeight = 0,
  className = "",
  headlineClassName = "",
  subtitle = "",
}) => {
  return (
    <div
      className={`sticky z-30 w-full bg-[var(--color-secondary-dark)] ${className}`}
      style={{
        top: `${navbarHeight}px`,
      }}
    >
      <div className="px-8 py-2 lg:px-10">
        <h1
          className={`text-2xl lg:text-3xl uppercase font-bold text-gray-900 text-left ${headlineClassName}`}
        >
          {headline}
        </h1>
        <h1 style={{ color: "black", fontStyle: "italic", textAlign: "left" }}>
          {subtitle}
        </h1>
      </div>
    </div>
  );
};

export default StickyHeadline;
